// ==================== SUBSCRIPTION PLANS SERVICE ====================

import apiService from './api';
import type { SubscriptionPlan } from '../types';

export const plansService = {
  /**
   * Get all active subscription plans (public endpoint)
   */
  getPlans: async (): Promise<SubscriptionPlan[]> => {
    const response = await apiService.get<SubscriptionPlan[]>('/public/plans');
    
    // Handle different response structures
    if (response.success && response.data) {
      // If data is already an array, return it
      if (Array.isArray(response.data)) {
        return response.data;
      }
      // If data is nested (response.data.data), extract it
      const nestedData = (response.data as unknown as { data?: SubscriptionPlan[] }).data;
      if (Array.isArray(nestedData)) {
        return nestedData;
      }
    }
    
    return [];
  },
};

export default plansService;
